import React, {useState} from "react";
import styled from "styled-components";
import Modal from '../../../../../../components/modal';
import { GroupButton } from './bulk-edit-groups-button'

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 32px;
`;

export const BulkEditGroups = ({assignType, open, onClose, handleSubmit, isLoading, disabled}) => {
  const [linkData, setLinkData] = useState('');
  return (
    <Modal
      title={assignType === 'add' ? "Add to group" : "Remove from group"}
      submitLabel="Confirm"
      open={open}
      onClose={() => {setLinkData(''); onClose();}}
      handleSubmit={() => { if (linkData?.id) handleSubmit(linkData.id)}}
      disabled={disabled}
      isLoading={isLoading}
    >
      <Container>
        <GroupButton
          linkData={linkData}
          setLinkData={setLinkData}
        />
      </Container>
      {/* <p>If a client's next check-in is within the next 5 days, their next check-in will be pushed a week later.</p> */}
    </Modal>
  );
};
